import { createSelector } from 'reselect';
import { disponentUserGroup } from '../../constants/UserGroups';
import * as User from 'utils/user';
import * as Customer from 'utils/customer';

export const selectUser = state => state.user;

export const selectIsUserFetching = createSelector([selectUser], user =>
  user.get('isFetching'),
);

export const selectIsUserLoggedIn = createSelector(
  [selectUser, selectIsUserFetching],
  (user, isFetching) => !isFetching && user.get('type') != null,
);

export const selectIsAdminUser = createSelector(
  [selectUser],
  user => user.get('type') === 'admin',
);
export const selectUserName = createSelector(
  [selectUser],
  user => `${user.get('givenName') || ''} ${user.get('surName') || ''}`,
);

export const selectUserId = createSelector([selectUser], user =>
  User.getUserId(user),
);

export const selectCustomerData = createSelector([selectUser], user =>
  User.getCustomerData(user),
);

export const selectSelectedAccount = createSelector(
  [selectCustomerData],
  customerData => Customer.getSelectedAccount(customerData),
);

export const selectMarginInfo = createSelector(
  [selectCustomerData],
  customerData => customerData.get('margin', {}),
);

export const selectIsPremiumAccount = createSelector(
  [selectSelectedAccount],
  Customer.getIsPremiumAccount,
);

export const selectAccounts = createSelector([selectCustomerData], customer =>
  customer.get('accounts'),
);

export const selectOwnAccounts = createSelector([selectAccounts], accounts => {
  return accounts.filter(
    account => !disponentUserGroup.includes(account.get('customerGroup')),
  );
});

export const selectDisposibleAccounts = createSelector(
  [selectAccounts],
  accounts => {
    return accounts.filter(account =>
      disponentUserGroup.includes(account.get('customerGroup')),
    );
  },
);
